import { Observable, switchMap, take, takeWhile, timer } from 'rxjs';

export const NACHLADEN_ABSTAND_MS = 3000;
export const NACHLADEN_VERSUCHE = 10;

const CODE_DIGITS = 6;
const MAX_CLEAN_LENGTH = 7;

export function cleanCode(value: string): string {
  return value.replace(/[^\d ]/gu, '').slice(0, MAX_CLEAN_LENGTH);
}

export function digitsOf(value: string): string {
  return value.replace(/\D/gu, '');
}

export function formatCode(value: string): string {
  const digits = digitsOf(value).slice(0, CODE_DIGITS);
  return digits.length > 3 ? `${digits.slice(0, 3)} ${digits.slice(3)}` : digits;
}

export function isSixDigits(value: string): boolean {
  return digitsOf(value).length === CODE_DIGITS;
}

export function pairingErrorKey(status: number): string {
  if (status === 404) {
    return 'runnerPairing.error.unknownCode';
  }
  if (status === 429) {
    return 'runnerPairing.error.tooManyAttempts';
  }
  return 'runnerPairing.error.generic';
}

export function packageFileName(platform: string): string {
  return `testoffice-runner-${platform}.zip`;
}

/** Der Rechner entsteht im Server erst, wenn der Runner den bestätigten Code abholt (alle paar Sekunden). */
export function waitForNewRunner<T>(load: () => Observable<T>, arrived: (value: T) => boolean): Observable<T> {
  return timer(0, NACHLADEN_ABSTAND_MS).pipe(
    take(NACHLADEN_VERSUCHE),
    switchMap(() => load()),
    takeWhile((value) => !arrived(value), true),
  );
}
